import React, { createContext, useContext, useState, useEffect } from 'react';
import axiosClient from '../api/axiosClient';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Helper to fetch user profile
  const fetchProfile = async () => {
      try {
        const profile = await axiosClient.get('/user/profile');
        setUser(profile);
        return true; // Success
      } catch (error) {
        console.error("Session invalid", error);
        localStorage.removeItem('admin_token');
        setUser(null);
        return false; // Failed
      }
  };

  // Check login status on startup
  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    if (token) {
        fetchProfile().finally(() => setLoading(false));
    } else {
        setLoading(false);
    }
  }, []);

  const loginWithToken = async (token) => {
      localStorage.setItem('admin_token', token);
      // Force axios to update header immediately for subsequent calls
      axiosClient.defaults.headers.Authorization = `Bearer ${token}`;
      
      await fetchProfile();
  };

  const logout = () => {
    localStorage.removeItem('admin_token');
    delete axiosClient.defaults.headers.Authorization; // Clear header
    setUser(null);
    window.location.href = '/login';
  };

  return (
    <AuthContext.Provider value={{ user, loginWithToken, logout, loading, isAuthenticated: !!user }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);